import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Paper, Grid } from '@mui/material';
import DashboardLayout from '../Sidebar/DashboardLayout';
import NiveauRecruteur from './NiveauRecruteur';
import BadgesRecruteur from './BadgesRecruteur';
import './RecruteurDetail.css';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Chatbox from '../../commun/ChatBox';
import LoadingPopup from "../../commun/LoadingPopup";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const RecruteurDetail = () => {
  const { id } = useParams();
  const [recruteur, setRecruteur] = useState(null);
  const [formData, setFormData] = useState({});
  const [editable, setEditable] = useState(false);
  const [stats, setStats] = useState(null);
  const [tab, setTab] = useState('niveau');
  const userRole = localStorage.getItem('userType');

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/recruteur/stats/${id}`);
        setStats(res.data);
      } catch (error) {
        console.error("Erreur chargement stats:", error);
      }
    };

    const fetchRecruteur = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/recruteur/profil/${id}`);
        setRecruteur(res.data);
        setFormData(res.data.utilisateur || {});
      } catch (error) {
        console.error("Erreur chargement recruteur:", error);
      }
    };

    fetchStats();
    fetchRecruteur();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      await axios.patch(`${API_BASE}/api/recruteur/edit/${formData._id}`, {
        utilisateur: formData
      });
      setEditable(false);
      alert("✅ Données enregistrées");
    } catch (error) {
      console.error("Erreur sauvegarde :", error);
      alert("❌ Échec de l’enregistrement");
    }
  };

  const handleCancel = () => {
    setFormData(recruteur.utilisateur || {});
    setEditable(false);
  };

  if (!recruteur) return 
    <div className="recruteur-loading">
    <LoadingPopup
      open={!recruteur}
      message="Chargement..."
    />
    </div>;

  return (
    <DashboardLayout>
      <Box className="recruteur-detail-container">
        <Box className="recruteur-header">
          <Typography variant="h4">{formData.firstName} {formData.lastName}</Typography>
          <div className="recruteur-badge-niveau">
            <span className="niveau-label" style={{ backgroundColor: stats?.niveau?.color || '#ccc' }}>
              {stats?.niveau?.label || 'Niveau inconnu'}
            </span>
          </div>
        </Box>

        <Paper className="info-section">
          <Typography variant="h6" className="section-title">Informations personnelles</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Prénom"
                name="firstName"
                value={formData.firstName || ''}
                onChange={handleChange}
                fullWidth
                disabled={!editable}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Nom"
                name="lastName"
                value={formData.lastName || ''}
                onChange={handleChange}
                fullWidth
                disabled={!editable}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Email"
                name="email"
                value={formData.email || ''}
                onChange={handleChange}
                fullWidth
                disabled={!editable}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Téléphone"
                name="phone"
                value={formData.phone || ''}
                onChange={handleChange}
                fullWidth
                disabled={!editable}
              />
            </Grid>
          </Grid>

          <Box className="btn-group">
            {editable ? (
              <>
                <Button variant="contained" onClick={handleSave}>Enregistrer</Button>
                <Button onClick={handleCancel}>Annuler</Button>
              </>
            ) : (
              <Button variant="outlined" onClick={() => setEditable(true)}>Modifier</Button>
            )}
          </Box>
        </Paper>

        <Box className="tab-buttons">
          <Button onClick={() => setTab('niveau')} variant={tab === 'niveau' ? 'contained' : 'outlined'}>
            Niveau
          </Button>
          <Button onClick={() => setTab('badges')} variant={tab === 'badges' ? 'contained' : 'outlined'}>
            Badges
          </Button>
        </Box>

        <Box className="tab-content">
          {tab === 'niveau' && <NiveauRecruteur niveau={stats?.niveau} stats={stats} />}
          {tab === 'badges' && <BadgesRecruteur stats={stats} />}
        </Box>
        {userRole !== 'agent' && <Chatbox userRole={userRole} />}
        </Box>
    </DashboardLayout>
  );
};

export default RecruteurDetail;
